module.exports = __webpack_public_path__ + "static/media/xml.f5e8eec1.png";